import { useState, useEffect } from 'react';
import { useMountedState } from 'react-use';
import { useGigerConfig } from '../../providers/useGigerConfig.js';

function useIconData(name) {
  const {
    resolveIcon,
    iconCache
  } = useGigerConfig();

  // useAsync, react-query and swr throw a act warning here (seems to be ignoring the isMounted hook) but this snippet doesn't
  // TODO: Investigate why and make this code more readable https://auctane.atlassian.net/browse/GIG-1196

  const isMounted = useMountedState();
  const [iconData, setIconData] = useState('');
  useEffect(() => {
    const cachedData = iconCache.get(name);
    if (cachedData) {
      setIconData(cachedData);
      return;
    }
    const resolveResult = resolveIcon(name);
    if (resolveResult instanceof Promise) {
      resolveResult.then(data => {
        if (isMounted()) {
          setIconData(data);
          iconCache.set(name, data);
        }
      });
    } else {
      setIconData(resolveResult);
    }
  }, [iconCache, isMounted, name, resolveIcon]);
  return iconData;
}

export { useIconData };
//# sourceMappingURL=useIconData.js.map
